import { render, staticRenderFns } from "./TabelaDepartamento.vue?vue&type=template&id=29880bbc&scoped=true"
import script from "./TabelaDepartamento.vue?vue&type=script&lang=js"
export * from "./TabelaDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29880bbc",
  null
  
)

export default component.exports